import { useState } from "react";
import { PlayCircle } from "lucide-react";
import { SHOWCASE_CATEGORIES } from "../data/content";

export default function LiveBuild() {
  const [cat, setCat] = useState("ALL");
  const cats = ["ALL", ...SHOWCASE_CATEGORIES];
  const tiles = cat === "ALL" ? SHOWCASE_CATEGORIES : [cat];

  return (
    <div className="pt-32 lg:pt-40 pb-24" data-testid="live-build-page">
      <div className="container-x">
        <div className="flex items-center gap-3">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse-dot" />
          <p className="section-label">LIVE BUILD SHOWCASE</p>
        </div>
        <h1 className="mt-5 font-heading text-5xl sm:text-6xl font-black tracking-tight text-white">
          WATCH US <span className="text-flame">BUILD.</span>
        </h1>
        <p className="mt-6 text-slate-400 max-w-2xl leading-relaxed">
          Live build recordings, screen captures, before/after walkthroughs and Rush Hour sessions. Recordings are
          published only with client consent — no fabricated showcases.
        </p>

        <div className="mt-12 flex flex-wrap gap-3" data-testid="showcase-filters">
          {cats.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setCat(c)}
              className={`rounded-full px-5 py-2 font-mono text-[10px] font-bold tracking-[0.2em] transition-colors ${
                cat === c ? "bg-flame text-white" : "border border-white/15 text-slate-300 hover:border-flame/50"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {tiles.map((c) => (
            <div key={c} data-testid={`showcase-video-${c.toLowerCase().replace(/\s+/g, "-")}`} className="relative aspect-video rounded-2xl border border-white/10 bg-navy-800 overflow-hidden group card-lift">
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                <PlayCircle className="w-12 h-12 text-slate-600 group-hover:text-flame transition-colors" />
                <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500">{c}</p>
                <p className="font-mono text-[9px] tracking-[0.2em] text-slate-600">VIDEO PLACEHOLDER — COMING SOON</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
